module.exports = __webpack_public_path__ + "img/Vertical_RGB_294.15b386aa.png";